import React, { useContext } from 'react'
import {
  IProps as ISecondaryNav,
  SecondaryNav,
} from 'marketing-site/src/library/components/SecondaryNav'
import { IProps as ISecondaryNavSection } from 'marketing-site/src/library/components/SecondaryNavSection'
import { ISecondaryNavSection as IContentfulSecondaryNavSection } from 'marketing-site/@types/generated/contentful'
import { ISecondaryNav as IContentfulSecondaryNav } from 'marketing-site/@types/generated/contentful'
import {
  transformHeaderNavigationLinkBadge,
  transformHeaderNavigationMenuItem,
} from 'marketing-site/src/transformers/components/ContentfulHeaderNavigation'
import CurrentLocaleContext from 'marketing-site/src/components/context/CurrentLocaleContext'
import { Locale } from 'contentful'

import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulSecondaryNav = (secondaryNav: IContentfulSecondaryNav) => {
  const currentLocale = useContext(CurrentLocaleContext)
  return (
    <EntryMarker entry={secondaryNav}>
      {() => <SecondaryNav {...transformSecondaryNav(secondaryNav, currentLocale)} />}
    </EntryMarker>
  )
}

export function transformSecondaryNav(
  { fields }: IContentfulSecondaryNav,
  locale: Locale,
): ISecondaryNav {
  const transformedData: ISecondaryNav = {
    ...fields,
    navSections: fields.sections.map((section: IContentfulSecondaryNavSection) =>
      transformSecondaryNavSection(section, locale),
    ),
  }
  return transformedData
}

function transformSecondaryNavSection(
  { fields }: IContentfulSecondaryNavSection,
  locale: Locale,
): ISecondaryNavSection {
  return {
    ...fields,
    menuItems: fields.menuItems?.map((item) => transformHeaderNavigationMenuItem(item, locale)),
    badge: fields.badge ? transformHeaderNavigationLinkBadge(fields.badge) : undefined,
  }
}
